import React, { useEffect, useState } from 'react'
import Header from '../header/Header';
import Footer from '../footer/Footer';
import { MdOutline3DRotation, MdOutlineVideoLibrary } from "react-icons/md";
import img1 from '../../Assests_Url/image-teach.png'
import img2 from '../../Assests_Url/image-video.png'
import video1 from '../../Assests_Url/Keyword_Enhancement.mp4'
import video2 from '../../Assests_Url/CONCEPT_AND_EXPLANATION_VIDEO.mp4'
import video3 from '../../Assests_Url/3D_Modal.mp4'
import video4 from '../../Assests_Url/Keyword_Enhancement.mp4'
import video5 from '../../Assests_Url/VIRTUAL_LAB.mp4'
import video6 from '../../Assests_Url/Interactive Exercises.mp4'
import { IoArrowUndoCircle, IoColorWandOutline } from "react-icons/io5";
import { PiVideoFill } from "react-icons/pi";
import mic from '../../Assests_Url/2d.png'
import vl from '../../Assests_Url/virtual_labs.png'
import iex from '../../Assests_Url/Inter_exer.png'
import { useNavigate } from 'react-router-dom';

const UTeachStandard = ({ RoutesClick, NcertClick }) => {
  const [registerModal, setRegisterModal] = useState(false);
  const [activeTabHeader, setActiveTabHeader] = React.useState("KATBOOK");
  const [studentregisterModal, setStudentRegisterModal] = useState(false);
  const [ParentregisterModal, setParentRegisterModal] = useState(false);
  const [TeacherregisterModal, setTeacherregisterModal] = useState(false);

  const handleTabClickHeader = (tab) => {
    setActiveTabHeader(tab);
  };

  useEffect(() => {
    // Scroll to the top of the page when the component mounts
    window.scrollTo(0, 0);
  }, []);

  const navigate = useNavigate()

  return (
    <div>
      <div>
        <Header
          activeTab={activeTabHeader}
          handleTabClick={handleTabClickHeader}
          studentregisterModal={studentregisterModal}
          setStudentRegisterModal={setStudentRegisterModal}
          ParentregisterModal={ParentregisterModal}
          setParentRegisterModal={setParentRegisterModal}
          TeacherregisterModal={TeacherregisterModal}
          setTeacherregisterModal={setTeacherregisterModal}
          registerModal={registerModal}
          setRegisterModal={setRegisterModal}
          RoutesClick={RoutesClick}
          NcertClick={NcertClick}
        />
      </div>

      <div className='container-uteach'>
        <div className='pt-5'>
          {/* <div className='found-font text-center pb-4'>
            UTeach Higher Standard Books
          </div> */}
          <div className='d-flex align-items-center justify-content-between text-center pb-4'>
            <div>
              <IoArrowUndoCircle size={30} className='back-arrow'
                onClick={() => {
                  navigate("/katbook", { state: { scroll: "bottom" } });
                }}
              />
            </div>
            <div className='found-font'>
              UTeach Higher Standard Books
            </div>
            <div></div>
          </div>

          <div className='d-flex flex-column align-items-center gap-3'>
            <div className='meta-font'>
              The Power of Meta Content
            </div>
            <div className='text-foun-font text-center'>
              NCERT KATBOOKS for higher classes are powered with state-of-the-art
              teaching resources curated by subject experts and global content
              creators.
            </div>
            <div className='text-foun-font text-center'>
              Teachers can use these advanced, ready-to-use digital resources to
              simplify complex concepts in science, mathematics, computer science,
              and much more
            </div>
          </div>

          <div className='pt-5'>
            <div className='d-flex flex-column gap-5'>

              <div>
                <div className='d-flex flex-column gap-3'>
                  <div className='cont-heading'>
                    1. Enhanced Keywords <IoColorWandOutline size={"25px"} />
                  </div>
                  <div className='cont-para d-flex flex-column gap-2'>
                    Important terms, formulae, and concepts are highlighted as keywords.
                    Teachers can click on them to open a side-by-side screen showing
                    definitions, explanations, derivations, and related references.

                    <ul>
                      <li>
                        Acts as a quick reference during class discussions.
                      </li>
                      <li>
                        Ensures consistent and standardised explanation of key terms
                      </li>
                    </ul>
                  </div>
                </div>

                <div className='d-flex align-items-center justify-content-center gap-3 w-100'>
                  {/* img */}
                  <div>
                    <img src={img1} alt='found-img' className='img-video' />
                  </div>

                  {/* Video */}
                  <div>
                    {/* <img src={img2} alt='found-video' className='img-video' /> */}
                    <video className='video-css'
                      width="540"
                      controls
                    >
                      <source src={video1} type="video/mp4" />
                    </video>
                  </div>
                </div>
              </div>

              <div>
                <div className='d-flex flex-column gap-3'>
                  <div className='cont-heading'>
                    2. Concept & Explanation Videos (Embedded) <PiVideoFill size={"25px"} />
                  </div>
                  <div className='cont-para d-flex flex-column gap-2'>
                    Concept & Explanation Videos are embedded from within the KATBOOK to
                    explain difficult or abstract concepts. Teachers can play, pause,
                    or project these videos in full screen directly without leaving the
                    KATBOOK window.

                    <ul>
                      <li>
                        Provides an instant teaching aid for abstract or complex topics.
                      </li>
                      <li>
                        Saves preparation time by removing the need for external sources.
                      </li>
                      <li>
                        Standardize the method of teaching for all teachers and schools.
                      </li>
                    </ul>
                  </div>
                </div>

                <div className='d-flex align-items-center justify-content-center gap-3 w-100'>
                  {/* img */}
                  <div>
                    <img src={img1} alt='found-img' className='img-video' />
                  </div>

                  {/* Video */}
                  <div>
                    {/* <img src={img2} alt='found-video' className='img-video' /> */}
                    <video className='video-css'
                      width="540"
                      controls
                    >
                      <source src={video2} type="video/mp4" />
                    </video>
                  </div>
                </div>
              </div>

              <div>
                <div className='d-flex flex-column gap-3'>
                  <div className='cont-heading'>
                    3. 3D Models & Activities <MdOutline3DRotation size={"25px"} />
                  </div>
                  <div className='cont-para d-flex flex-column gap-2'>
                    Interactive 3D models of molecules, body systems, geometric structures,
                    and lab apparatus are available from within the KATBOOK. Teachers can
                    rotate, zoom, and demonstrate them in class.

                    <ul>
                      <li>
                        Improves understanding of abstract diagrams and scientific structures.
                      </li>
                      <li>
                        Makes complex concepts more tangible and interactive.
                      </li>
                    </ul>
                  </div>
                </div>

                <div className='d-flex align-items-center justify-content-center gap-3 w-100'>
                  {/* img */}
                  <div>
                    <img src={img1} alt='found-img' className='img-video' />
                  </div>

                  {/* Video */}
                  <div>
                    {/* <img src={img2} alt='found-video' className='img-video' /> */}
                    <video className='video-css'
                      width="540"
                      controls
                    >
                      <source src={video3} type="video/mp4" />
                    </video>
                  </div>
                </div>
              </div>

              <div>
                <div className='d-flex flex-column gap-3'>
                  <div className='cont-heading'>
                    4. 2D Animations <img src={mic} width={"2%"} />
                  </div>
                  <div className='cont-para d-flex flex-column gap-2'>
                    Step-by-step animations illustrate processes such as chemical reactions,
                    biological functions, physical laws, and much more

                    <ul>
                      <li>
                        Simplifies difficult concepts by breaking them into visual sequences.
                      </li>
                      <li>
                        Assists teachers in explaining processes clearly and systematically.
                      </li>
                    </ul>
                  </div>
                </div>

                <div className='d-flex align-items-center justify-content-center gap-3 w-100'>
                  {/* img */}
                  <div>
                    <img src={img1} alt='found-img' className='img-video' />
                  </div>

                  {/* Video */}
                  <div>
                    {/* <img src={img2} alt='found-video' className='img-video' /> */}
                    <video className='video-css'
                      width="540"
                      controls
                    >
                      <source src={""} type="video/mp4" />
                    </video>
                  </div>
                </div>
              </div>

              <div>
                <div className='d-flex flex-column gap-3'>
                  <div className='cont-heading'>
                    5. Virtual Labs <img src={vl} width={"2%"} />
                  </div>
                  <div className='cont-para d-flex flex-column gap-2'>
                    Fully simulated laboratory experiments with a step by step interactive
                    methodology is available from within the KATBOOK. This environment
                    enables students to perform experiments digitally in Physics,
                    Chemistry, and Biology.

                    <ul>
                      <li>
                        Offers repeatable, and cost-effective practice for experiments.
                      </li>
                      <li>
                        Ensures practical learning continues even in resource-constrained settings
                      </li>
                    </ul>
                  </div>
                </div>

                <div className='d-flex align-items-center justify-content-center gap-3 w-100'>
                  {/* img */}
                  <div>
                    <img src={img1} alt='found-img' className='img-video' />
                  </div>

                  {/* Video */}
                  <div>
                    {/* <img src={img2} alt='found-video' className='img-video' /> */}
                    <video className='video-css'
                      width="540"
                      controls
                    >
                      <source src={video5} type="video/mp4" />
                    </video>
                  </div>
                </div>
              </div>

              <div>
                <div className='d-flex flex-column gap-3'>
                  <div className='cont-heading'>
                    6. Interactive Exercises <img src={iex} width={"2%"} />
                  </div>
                  <div className='cont-para d-flex flex-column gap-2'>
                    Session-based interactive activities such as classification, drag-and-drop
                    tasks, and application-based problem-solving exercises are included.
                    Teachers can involve students in solving these activities during class.

                    <ul>
                      <li>
                        Promotes higher-order thinking and concept application.
                      </li>
                      <li>
                        Increases student participation and classroom engagement.
                      </li>
                    </ul>
                  </div>
                </div>

                <div className='d-flex align-items-center justify-content-center gap-3 w-100'>
                  {/* img */}
                  <div>
                    <img src={img1} alt='found-img' className='img-video' />
                  </div>

                  {/* Video */}
                  <div>
                    {/* <img src={img2} alt='found-video' className='img-video' /> */}
                    <video className='video-css'
                      width="540"
                      controls
                    >
                      <source src={video6} type="video/mp4" />
                    </video>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>

      <div>
        <Footer
          setActiveTab={setActiveTabHeader}
          RoutesClick={RoutesClick}
          NcertClick={NcertClick}
        />
      </div>
    </div>
  )
}

export default UTeachStandard
